function handleClickOutside(el, binding) {
    if (typeof binding.value !== 'function' && typeof binding.value.handler !== 'function') {
        console.warn(`[click-outside:] handler for '${binding.expression}' is missing`);
    }

    const callback = binding.value.handler || binding.value;
    const { exclude = [] } = binding.value;

    const handler = e => {
        const clickedOnExcludedElement = exclude.some(ex => {
            const ref = typeof ex === 'string' ? binding.instance.$refs[ex] : ex;

            if (!ref) return false;

            let el = e.target;

            do {
                if (el === ref) return true;
                el = el.parentNode;
            } while (el !== null && el.nodeType === 1);

            return false;
        });

        if (!el.contains(e.target) && !clickedOnExcludedElement) return callback(e);
    };

    if (el.vClickOutside) document.removeEventListener('click', el.vClickOutside);
    el.vClickOutside = handler;
    document.addEventListener('click', handler);
}

export default {
    name: 'click-outside',
    beforeMount(el, binding) {
        if (binding.arg !== 'hook' || !binding.modifiers?.beforeUpdate) handleClickOutside(el, binding);
    },
    beforeUpdate(el, binding) {
        if (binding.arg === 'hook' && binding.modifiers?.beforeUpdate) handleClickOutside(el, binding);
    },
    updated(el, binding) {
        if (binding.arg === 'hook' && binding.modifiers?.updated) handleClickOutside(el, binding);
    },
    unmounted(el) {
        document.removeEventListener('click', el.vClickOutside);
        el.vClickOutside = null;
    },
};
